<section class="content">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-md-6 mb-2">
        <span class="mb-0 page-title">{{'PROFILE' | translate}}</span>
      </div>
      <div class="col-md-6 d-flex justify-content-end mb-2">
        <button class="primary me-2" matButton="filled" (click)="changePassword()">
          <mat-icon class="medium-icon fs-5 align-middle">lock</mat-icon>
          {{'CHANGE_PASSWORD' | translate}}
        </button>
      </div>
    </div>
    <mat-card>
      <mat-card-content>
        <form [formGroup]="userForm">
          <mat-card appearance="outlined">
            <mat-card-content>
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group ">
                        <label class="text-danger">{{'FIRST_NAME' | translate}} *</label>
                        <input formControlName="firstName" class="form-control" type="text">
                        @if(userForm.get('firstName')?.touched && userForm.get('firstName')?.errors &&
                        userForm.get('firstName')?.errors?.['required']){
                        <div class="text-danger">
                          {{'FIRST_NAME_IS_REQUIRED' | translate}}
                        </div>
                        }

                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group ">
                        <label class="text-danger">{{'LAST_NAME' | translate}} *</label>
                        <input formControlName="lastName" class="form-control" type="text">
                        @if(userForm.get('lastName')?.touched && userForm.get('lastName')?.errors &&
                        userForm.get('lastName')?.errors?.['required']){
                        <div class="text-danger">
                          {{'LAST_NAME_IS_REQUIRED' | translate}}
                        </div>
                        }
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group ">
                        <label class="text-danger">{{'MOBILE_NUMBER' | translate}} *</label>
                        <input formControlName="phoneNumber" class="form-control" type="text">
                        @if(userForm.get('phoneNumber')?.touched && userForm.get('phoneNumber')?.errors &&
                        userForm.get('phoneNumber')?.errors?.['required']){
                        <div class="text-danger">
                          {{'MOBILE_IS_REQUIRED' | translate}}
                        </div>
                        }
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>{{'EMAIL' | translate}}</label>
                        <input [attr.disabled]="true" formControlName="email" class="form-control" type="email">
                      </div>
                    </div>
                    <div class="form-group col-md-12">
                      <label>{{'ADDRESS' | translate}}</label>
                      <textarea formControlName="address" class="form-control"></textarea>
                    </div>
                    <div class="mt-3 col-md-6">
                      <button class="success btn-sm me-2" matButton="filled" (click)="updateProfile()" cdkFocusInitial>
                        <mat-icon class="medium-icon fs-5 align-middle">save</mat-icon> {{'SAVE' | translate}}
                      </button>
                      <button type="button" class="error" matButton="filled" (click)="onCancle()">
                        <mat-icon class="medium-icon fs-5 align-middle">cancel</mat-icon>
                        {{'CANCEL' | translate}}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row justify-content-center">
                    <div class="d-flex flex-column align-items-center w-100">
                      <mat-card appearance="outlined" class="w-100 text-center pb-2" [dir]="langDir" style="max-width: 320px;">
                      <mat-card-header [dir]="langDir" class="justify-content-center">
                        <mat-card-title [dir]="langDir" class="w-100">{{'PROFILE_PHOTO' | translate}}</mat-card-title>
                      </mat-card-header>
                      <div class="my-3 d-flex justify-content-center">
                        <input hidden (change)="onFileSelect($event)" #fileInput name="logo" type="file" name="Profile Photo">
                        @if(imgSrc){
                        <img class="user-img rounded-circle border border-2" [src]="imgSrc" style="width:120px;height:120px;object-fit:cover;" />
                        } @else {
                        <img class="user-img rounded-circle border border-2" src="/images/user-profile.jpg" style="width:120px;height:120px;object-fit:cover;" />
                        }
                      </div>
                      <mat-card-actions class="d-flex justify-content-center gap-2">
                        @if(imgSrc){
                        <button class="success me-2" matButton="filled" (click)="fileInput.click()">
                          <mat-icon class="medium-icon fs-5 align-middle">image</mat-icon> {{'CHANGE' | translate}}
                        </button>
                        <button type="button" (click)="onRemoveImage()" class="error" matButton="filled">
                          <mat-icon class="medium-icon fs-5 align-middle">delete</mat-icon> {{'REMOVE' | translate}}
                        </button>
                        } @else {
                        <button class="success me-2" matButton="filled" (click)="fileInput.click()">
                          <mat-icon class="medium-icon fs-5 align-middle">image</mat-icon> {{'ADD_PHOTO' | translate}}
                        </button>
                        }
                      </mat-card-actions>
                      </mat-card>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</section>